<div class="row">
  <div class="col-lg-10">
    <h2>{{application.applicationName}}</h2>
    <br>
  </div>
</div>
<div class="row">
  <div class="col-sm-11">

    <form #detailsForm="ngForm" (ngSubmit)="updateApplication();" role="form">
      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Success
          API URL<em aria-hidden="true" class="fa fa-question"
                     style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                     title="{{successApiUrlTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input #successURL="ngModel" [(ngModel)]="application.successUrl" [ngClass]="successURL.errors  ? 'has-danger':'has-success'"
                   [readonly]="edit" class="form-control field" id="successURL"
                   name="successUrl" required
                   type="text">
          </div>
          <div *ngIf="successURL.errors && (successURL.dirty || successURL.touched)"
               class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!successURL.errors.required">
							<span style="color: red; font-weight: bold">Application
								Success API URL is required</span>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Failure
          API URL<em aria-hidden="true" class="fa fa-question"
                     style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                     title="{{failureApiUrlTitle}}"></em>
        </label>
        <div class="row">

          <div class="col-sm-7">
            <input #failureURL="ngModel" [(ngModel)]="application.failureUrl" [ngClass]="failureURL.errors  ? 'has-danger':'has-success'"
                   [readonly]="edit" class="form-control field" id="failureURL"
                   name="failureUrl" required
                   type="text">
          </div>
          <div *ngIf="failureURL.errors && (failureURL.dirty || failureURL.touched)"
               class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!failureURL.errors.required">
							<span style="color: red; font-weight: bold">Application
								Failure API URL is required</span>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Cyberscore
          Threshold<em aria-hidden="true" class="fa fa-question"
                       style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                       title="{{cyberscoreThresholdTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input #cyberScoreThreshold="ngModel" (keyup)="validateCyberscoreThresholdRange()"
                   [(ngModel)]="application.cyberScoreThreshold"
                   [ngClass]="cyberScoreThreshold.errors  ? 'has-danger':'has-success'" [readonly]="edit" class="form-control field"
                   id="cyberScoreThreshold"
                   max="800" min="0"
                   name="cyberScoreThreshold"
                   required
                   type="number">
          </div>
          <div
            *ngIf="cyberScoreThreshold.errors && (cyberScoreThreshold.dirty || cyberScoreThreshold.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!cyberScoreThreshold.errors.required">
							<span style="color: red; font-weight: bold"> Cyberscore
								Threshold is required</span>
            </div>
          </div>
          <div [ngStyle]="{'display': 'none'}"
               class="form-control-feedback error-text col-sm-5"
               id="cyberScoreThresholdRangeErrorDiv">
            <span style="color: red; font-weight: bold">Cyberscore threshold must be between 0 to 800</span>
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">API
          Key<em aria-hidden="true" class="fa fa-question"
                 style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                 title="{{apiKeyTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input #apiKey="ngModel" [(ngModel)]="application.apiKey" class="form-control field"
                   id="apiKey"
                   name="apiKey" readonly type="text">
          </div>
          <button (click)="regenerateApiKey()" *ngIf="!edit" class="btn btn-primary" type="button">
            Regenerate
            Api Key
          </button>

        </div>
      </fieldset>

      <!--
        Allow a user to login, even if no Entreda App is installed. Ask for the Grace period. Default is 0
      -->

      <fieldset [disabled]="edit" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;">
          Allow a grace period for users to login if no Unify Applet is
          installed on device? <em aria-hidden="true" class="fa fa-question"
                                   style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                                   title={{allowLoginGracePeriod}}></em>
        </label>
        <div *ngIf="byPassAppletCheck==true" class="col-sm-12" style="margin-bottom: 9px;">
          <span class="">Start Date: {{startDateOfByPassAgentActivation}}</span>
          <br/>
          <span class="">No. of Days Passed: {{noOfDaysByPassAgentActivation}} days</span>
        </div>
        <div class="row">
          <div class="col-sm-7">
            <input (click)="validateGroupDays(true)" [(ngModel)]="byPassAppletCheck" [disabled]="edit"
                   [value]="true"
                   name="byPassAppletCheck" style="margin-left: 20%" type="radio"> YES
            <input (click)="validateGroupDays(false)" [(ngModel)]="byPassAppletCheck" [disabled]="edit"
                   [value]="false"
                   name="byPassAppletCheck" style="margin-left: 20%" type="radio"> NO
          </div>
        </div>
      </fieldset>

      <fieldset [hidden]="!byPassAppletCheck" class="collapsible" id="gracePeriodSelector">
        <legend></legend>
        <fieldset class="form-group">
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col col-form-label" style="max-width: 100%">Group
                1: <span style="color: blue"> {{
									numberofDaysRemainingGroup1 }} </span>
              </label>
            </div>
            <div class="col-sm-6">
              <select [(ngModel)]="byPassValueGroup1" [disabled]="edit"
                      [required]="byPassAppletCheck" class="form-control"
                      id="byPassValueDropownGroup1"
                      name="byPassValueDropownGroup1" style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup1" [ngValue]="byPassVal">
                  {{ byPassVal }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" for="emailGroup1"
                     style="max-width: 58%">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:</label>
            </div>
          </div>
          <div class="row">
            <div *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'"
                 class="col-sm-7">
							<textarea MultiEmailValidationDirective [(ngModel)]="emailValueGroup1"
                        [disabled]="!byPassAppletCheck"
                        [readonly]="edit" class="form-control z-depth-1"
                        id="emailGroup1"
                        name="emailGroup1" placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                        rows="3"
                        style="margin-left: 13px;"></textarea>
            </div>
            <div *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'"
                 class="col-sm-7">
							<textarea [(ngModel)]="emailValueGroup1" [disabled]="!byPassAppletCheck"
                        [readonly]="edit"
                        class="form-control z-depth-1" id="emailGroup1"
                        name="emailGroup1"
                        placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma" rows="3"
                        style="margin-left: 13px;"></textarea>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-group">
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col col-form-label" style="max-width: 100%">Group
                2: <span style="color: blue"> {{
									numberofDaysRemainingGroup2 }} </span>
              </label>
            </div>
            <div class="col-sm-6">
              <select [(ngModel)]="byPassValueGroup2" [disabled]="edit"
                      [required]="byPassAppletCheck"
                      class="form-control" id="byPassValueDropown2" name="byPassValueDropown2"
                      style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup2" [ngValue]="byPassVal">
                  {{ byPassVal }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" for="emailGroup1"
                     style="max-width: 58%">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7 has-error">
							<textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'" MultiEmailValidationDirective
                        [(ngModel)]="emailValueGroup2"
                        [readonly]="edit"
                        class="form-control z-depth-1" id="emailGroup2"
                        name="emailGroup2"
                        placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma" rows="3"
                        style="margin-left: 13px;"></textarea>

              <textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'" [(ngModel)]="emailValueGroup2"
                        [readonly]="edit"
                        class="form-control z-depth-1"
                        id="emailGroup2" name="emailGroup2"
                        placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                        rows="3" style="margin-left: 13px;"></textarea>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-group" collapse>
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col col-form-label" style="max-width: 100%">Group
                3: <span style="color: blue"> {{
									numberofDaysRemainingGroup3 }} </span>
              </label>
            </div>
            <div class="col-sm-6">
              <select [(ngModel)]="byPassValueGroup3" [disabled]="edit"
                      [required]="byPassAppletCheck"
                      class="form-control" id="byPassValueDropown3" name="byPassValueDropown3"
                      style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup3" [ngValue]="byPassVal">
                  {{ byPassVal }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" for="emailGroup3"
                     style="max-width: 58%">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}: </label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7" style="max-width: 56.33%">
							<textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'"
                        MultiEmailValidationDirective
                        [(ngModel)]="emailValueGroup3" [readonly]="edit" class="form-control z-depth-1" id="emailGroup3"
                        name="emailGroup3"
                        placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma" rows="3"
                        style="margin-left: 13px;"></textarea>

              <textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'"
                        [(ngModel)]="emailValueGroup3"
                        [readonly]="edit" class="form-control z-depth-1" id="emailGroup3" name="emailGroup3"
                        placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                        rows="3" style="margin-left: 13px;"></textarea>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-group" collapse>
          <div class="row">
            <div class="col-sm-5">
              <label class="col-sm-5 col-form-label">Group 4: </label>
            </div>
            <div class="col-sm-2">
              <input #group4Days="ngModel" (blur)="checkGroup4UpdatedDays()" (keypress)="keyPressNumbers($event)"
                     (keyup)="validateGroup4Days()" [(ngModel)]="group4DaysValue" [ngClass]="group4Days.errors ? 'has-danger' : 'has-success'"
                     [readonly]="edit" [required]="gracePeriodApplyToAllUsersCheck"
                     class="form-control field" id="group4Days"
                     name="group4Days"
                     placeholder="No of Days"
                     type="text"/>
            </div>
            <div *ngIf="group4Days.errors" class="form-control-feedback error-text col-sm-5"
                 id="group4DaysRequiredDiv">
              <div [hidden]="!group4Days.errors.required">
                <span style="color: red; font-weight: bold">Required</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7 col-form-label">
              &nbsp;&nbsp;&nbsp;&nbsp;Apply to all users &nbsp;&nbsp;<input #gracePeriodApplyToAllUsers
                                                                            (keyup)="validateGroup4Days()"
                                                                            [(ngModel)]="gracePeriodApplyToAllUsersCheck"
                                                                            [disabled]="edit"
                                                                            [value]="false"
                                                                            id="gracePeriodApplyToAllUsers"
                                                                            name="gracePeriodApplyToAllUsers"
                                                                            type="checkbox"/>
              <i aria-hidden="true" class="fa fa-question" style="
				                padding: 5px;
				                padding-left: 7px;
				                padding-right: 7px;
				                float: right;
				              " title="{{ group4InfoText }}"></i>
            </div>
          </div>
        </fieldset>

      </fieldset>

      <fieldset [disabled]="edit" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Allow
          selected users to bypass authentication service?<em
            aria-hidden="true"
            class="fa fa-question" style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" title="{{allowBypassIpaddressTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.appletcheckByPassIpaddress" [disabled]="edit"
                   [value]="true" name="bypassIpAddress"
                   style="margin-left: 20%"
                   type="radio">
            YES <input [(ngModel)]="application.appletcheckByPassIpaddress" [checked]
                       [disabled]="edit" [value]="false"
                       name="bypassIpAddress"
                       style="margin-left: 20%" type="radio"> NO
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="application.appletcheckByPassIpaddress" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Public
          IP addresses:<em aria-hidden="true"
                           class="fa" style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></em>
        </label>
        <div *ngIf="application.appletcheckByPassIpaddress" class="row">
          <div class="col-sm-7 has-error">
						<textarea #ipDirectiveRef="ipaddressValidation" IpaddressValidation
                      [(ngModel)]="ipAddressGroup"
                      [readonly]="edit" class="form-control z-depth-1"
                      id="ipAddressGroup"
                      name="ipAddressGroup" placeholder="Enter public IP addresses separated by a comma. For example: 148.64.99.217, 2001:0db8:85a3:0000:0000:8a2e:0370:7334" rows="3"
                      style="margin-left: 13px;"></textarea>
            <div *ngIf="ipDirectiveRef.error" class="form-control-feedback error-text col-sm-10">
              <div [hidden]="!ipDirectiveRef.error">
								<span style="color: red; font-weight: bold"> {{
									ipDirectiveRef.errorMessage }} </span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="application.appletcheckByPassIpaddress" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label"
               style="max-width: 58%">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:<em
          aria-hidden="true" class="fa"
          style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></em>
        </label>
        <div *ngIf="application.appletcheckByPassIpaddress" class="row">
          <div class="col-sm-7 has-error">
						<textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'"
                      MultiEmailValidationDirective [(ngModel)]="emailbyPassGroup"
                      [readonly]="edit"
                      class="form-control z-depth-1" id="emailbypassGroup"
                      name="emailbypassGroup"
                      placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITHOUT_S_ADDRESSES}} separated by a comma. For example: {{validationMessages.MULTIPLE_EMAIL_V2020_EXAMPLE}}" rows="3"
                      style="margin-left: 13px;"></textarea>
            <textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'"
                      [(ngModel)]="emailbyPassGroup" [readonly]="edit"
                      class="form-control z-depth-1"
                      id="emailbypassGroup" name="emailbypassGroup"
                      placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITHOUT_S_ADDRESSES}} separated by a comma. For example: {{validationMessages.MULTIPLE_EMAIL_V2020_EXAMPLE}}"
                      rows="3" style="margin-left: 13px;"></textarea>
          </div>
        </div>
      </fieldset>

      <fieldset [disabled]="edit" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Allow
          user to login if cyberscore does not meet threshold<em
            aria-hidden="true"
            class="fa fa-question" style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" title="{{allowFailureTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input (click)="resetData()" [(ngModel)]="isFailureAllow" [checked]="isFailureAllow === true"
                   [disabled]="edit"
                   [value]="true" name="isFailureAllow" style="margin-left: 20%"
                   type="radio">
            YES <input (click)="clearData()" [(ngModel)]="isFailureAllow" [checked]="isFailureAllow === false"
                       [disabled]="edit"
                       [value]="false" name="isFailureAllow" style="margin-left: 20%"
                       type="radio"> NO
          </div>
        </div>

      </fieldset>
      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Number
          of attempts allowed<em aria-hidden="true" class="fa fa-question"
                                 style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                                 title="{{numberAttemptsAllowedTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input #maxFailedRetriesAttempts="ngModel"
                   (keyup)="validateMaxFailedRetriesAttempts()"
                   [(ngModel)]="application.maxFailedRetriesAttempts"
                   [ngClass]="maxFailedRetriesAttempts.errors  ? 'has-danger':'has-success'"
                   [readonly]="!isFailureAllow"
                   class="form-control field" id="numberAttemptsAllowed"
                   max="{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}" min="{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
                   name="maxFailedRetriesAttempts"
                   required type="number">
          </div>
          <div
            *ngIf="maxFailedRetriesAttempts.errors && (maxFailedRetriesAttempts.dirty || maxFailedRetriesAttempts.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!maxFailedRetriesAttempts.errors.required">
              <span style="color: red; font-weight: bold">Required</span>
            </div>
          </div>
          <div [ngStyle]="{'display': 'none'}"
               class="form-control-feedback error-text col-sm-5"
               id="maxFailedRetriesAttemptsRangeErrorDiv">
						<span style="color: red; font-weight: bold">Number of attempts must be between
							{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}} to
							{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}</span>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label">Time
          period (days)<em aria-hidden="true" class="fa fa-question" style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                           title="{{timePeriodTitle}}"></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input #retriesFailedPeriod="ngModel" (keyup)="validateRetriesFailedPeriod()"
                   [(ngModel)]="application.retriesFailedPeriod"
                   [ngClass]="retriesFailedPeriod.errors  ? 'has-danger':'has-success'"
                   [readonly]="!isFailureAllow"
                   class="form-control field" id="retriesFailedPeriod"
                   max="{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
                   min="{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
                   name="retriesFailedPeriod"
                   required type="number">
          </div>
          <div
            *ngIf="retriesFailedPeriod.errors && (retriesFailedPeriod.dirty || retriesFailedPeriod.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!retriesFailedPeriod.errors.required">
              <span style="color: red; font-weight: bold">Required</span>
            </div>
          </div>
          <div [ngStyle]="{'display': 'none'}"
               class="form-control-feedback error-text col-sm-5"
               id="retriesFailedPeriodRangeErrorDiv">
						<span style="color: red; font-weight: bold">Time period must be between
							{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}} to
							{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}
							days</span>
          </div>
        </div>
      </fieldset>


      <fieldset [disabled]="edit" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;">
          Enable remediation? <em aria-hidden="true" class="fa fa-question"
                                  style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                                  title={{enableRemediationTitle}}></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="enableRemediation" [checked]="enableRemediation === true" [disabled]="edit"
                   [value]="true" name="enableRemediation" style="margin-left: 20%"
                   type="radio">
            YES <input [(ngModel)]="enableRemediation" [checked]="enableRemediation === true" [disabled]="edit"
                       [value]="false" name="enableRemediation"
                       style="margin-left: 20%" type="radio">
            NO
          </div>
        </div>
      </fieldset>

      <fieldset [disabled]="edit" class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;">
          First time install: Allow User to authenticate after enrolling
          device? <em aria-hidden="true" class="fa fa-question"
                      style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                      title={{skipAppletCheckAfterInstallingTitle}}></em>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="skipAppletCheckAfterInstalling" [checked]="skipAppletCheckAfterInstalling === true"
                   [disabled]="edit"
                   [value]="true" name="skipAppletCheckAfterInstalling" style="margin-left: 20%"
                   type="radio"> YES
            <input [(ngModel)]="skipAppletCheckAfterInstalling" [checked]="skipAppletCheckAfterInstalling === true"
                   [disabled]="edit"
                   [value]="false" name="skipAppletCheckAfterInstalling" style="margin-left: 20%"
                   type="radio"> NO
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <div class="row">
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-12">
                <label class="col-sm-12 col-form-label" style="padding-right: 6px;"> Select the
                  additional user related
                  services you want to integrate below:
                  <i aria-hidden="true" class="fa fa-question"
                     style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
                     title={{thirdPartyServiceString}}></i>
                </label>
              </div>
              <fieldset [disabled]="edit" class="col-sm-12">
                <div class="col-sm-12">
                  <input (click)="togglePhishingUI()" [checked]="enablePhishing" name="enablePhishing"
                         style="margin-left: 2.7%" type="checkbox">
                  Phishing
                </div>
                <!--                <div class="col-sm-12">-->
                <!--                  <input style="margin-left: 2.7%;margin-top: 5%;" type="checkbox"-->
                <!--                         [checked]="enableSAT" (click)="toggleSatUI()" name="enableSAT"> SAT-->
                <!--                </div>-->
                <!--                <div *ngIf="!enablePhishing && !enableSAT"-->
                <!--                     class="form-control-feedback error-text col-sm-12">-->

              </fieldset>

            </div>
          </div>
        </div>
      </fieldset>
      <!-- <fieldset [disabled]="edit" [ngStyle]="{'display': enableSAT  ? 'block' : 'none' }"
                class="form-group">
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Training Survey Required for
          Training
          completion
          <i aria-hidden="true" class="fa fa-question"
             style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
             title={{satCompulsaryToLoginInstr}}></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <fieldset [disabled]="edit">
              <input (click)="toggleMandatorySATForLogin(true)" [(ngModel)]="application.trainingSurveyRequiredForTrainingCompletion"
                     [disabled]="edit"
                     [value]="true"
                     name="mandatorySATForLogin" style="margin-left: 20%" type="radio"> YES
              <input (click)="toggleMandatorySATForLogin(false)" [(ngModel)]="application.trainingSurveyRequiredForTrainingCompletion"
                     [checked]
                     [disabled]="edit"
                     [value]="false" name="mandatorySATForLogin" style="margin-left: 20%" type="radio">
              NO
            </fieldset>
          </div>
        </div>
      </fieldset> -->

      <!-- <fieldset [ngStyle]="{'display': (enableSAT && !application.trainingSurveyRequiredForTrainingCompletion) ? 'block' : 'none' }"
                class="form-group">
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Number of time user is
          allowed in before
          having
          to take the exam
          <i aria-hidden="true" class="fa fa-question"
             style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
             title={{satReminderAttemptCountString}}></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <fieldset class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <input #satReminderAttemptCount="ngModel"
                         (blur)="validateSatReminderAttemptCountRange()" (keyup)="validateSatReminderAttemptCountRange()" [(ngModel)]="application.numberAllowedLoginBeforeTakingExam" [disabled]="edit"
                         [ngClass]="satReminderAttemptCount.errors  ? 'has-danger':'has-success'"
                         class="form-control field" id="satReminderAttemptCount"
                         max="100" min="0"
                         name="satReminderAttemptCount"
                         type="number">
                </div>
                <div *ngIf="satReminderAttemptCount.errors && (satReminderAttemptCount.dirty || satReminderAttemptCount.touched)"
                                                class="form-control-feedback error-text col-sm-12">
                                                <div [hidden]="!satReminderAttemptCount.errors.required">
                                                    <span style="color: red; font-weight: bold"> Reminder attempt number is
                                                        required</span>
                                                </div>
                                            </div> 
                <div [ngStyle]="{'display': 'none'}"
                     class="form-control-feedback error-text col-sm-12"
                     id="satReminderAttemptCountRangeErrorDiv">
									<span style="color: red; font-weight: bold"> Reminder attempt number must be between
										1 to
										100</span>
                </div>
                <div [ngStyle]="{'display': 'none'}"
                     class="form-control-feedback error-text col-sm-12"
                     id="satReminderAttemptCountEmptyErrorDiv">
									<span style="color: red; font-weight: bold"> Reminder attempt number is
										required</span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </fieldset> -->

      <fieldset class="form-group">
        <label class="col-sm-7 col-form-label">
          Enable Help Button?
          <i
            aria-hidden="true"
            class="fa fa-question"
            style="
					  padding: 5px;
					  padding-left: 7px;
					  padding-right: 7px;
					  float: right;
					"
            title="{{ enableHelpTitle }}"
          ></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input
              (click)="resetHelpButtonData()"
              [(ngModel)]="enableHelp"
              [checked]="enableHelp === true"
              [disabled]="edit"
              [value]="true"
              name="enableHelp"
              style="margin-left: 20%"
              type="radio"
            />
            YES
            <input
              (click)="clearHelpButtonData()"
              [(ngModel)]="enableHelp"
              [checked]="enableHelp === false"
              [disabled]="edit"
              [value]="false"
              name="enableHelp"
              style="margin-left: 20%"
              type="radio"
            />
            NO
          </div>
        </div>
      </fieldset>

      <fieldset [hidden]="!enableHelp" class="collapsible" id="helpButtonAttempt">
        <fieldset [disabled]="edit" class="form-group">
          <label class="col-sm-7 col-form-label">
            Number of Help attempts allowed
            <i aria-hidden="true" class="fa fa-question"
               style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
               title="{{helpAttemptsAllowedTitle}}"></i>
          </label>
          <div class="row">
            <div class="col-sm-7">
              <input #maxHelpButtonAttempt="ngModel" (blur)="validateMaxHelpAttempts()"
                     (keyup)="validateMaxHelpAttempts()" [(ngModel)]="application.maxHelpButtonAttempt" [ngClass]="maxHelpButtonAttempt.errors  ? 'has-danger':'has-success'" [readonly]="!enableHelp"
                     class="form-control field"
                     id="maxHelpButtonAttemptsAllowed" max="999"
                     min="0"
                     name="maxHelpButtonAttempt"
                     required type="number">
            </div>
            <div
              *ngIf="maxHelpButtonAttempt.errors && (maxHelpButtonAttempt.dirty || maxHelpButtonAttempt.touched)"
              class="form-control-feedback error-text col-sm-5">
              <div [hidden]="!maxHelpButtonAttempt.errors.required">
                <span style="color: red; font-weight: bold">Required</span>
              </div>
            </div>
            <div [ngStyle]="{'display': 'none'}"
                 class="form-control-feedback error-text col-sm-5"
                 id="maxHelpButtonAttemptRangeErrorDiv">
              <span style="color: red; font-weight: bold">Number of attempts must be between 1 to 999</span>
            </div>
          </div>
        </fieldset>
      </fieldset>

      <fieldset *ngIf="edit" class="form-group row">
        <legend></legend>
        <div class="col-sm-5">
          <button (click)="update()" class="btn btn-primary"  style="margin-right: 0.5rem;" type="button">Edit</button>
          <button (click)="goBack()" class="btn btn-primary" type="button">Back</button>
        </div>
      </fieldset>

      <fieldset *ngIf="!edit" class="form-group row">
        <legend></legend>
        <div class="col-sm-5">
          <button [disabled]="!detailsForm.form.valid || !isValidForm" class="btn btn-primary" style="margin-right: 0.5rem;"
                  type="submit">Update
          </button>
          <button (click)="cancel()" class="btn btn-primary" type="button">Cancel</button>
        </div>
      </fieldset>
    </form>

    <br> <span align="left" style="font-size: 17px">Application
			created by: {{application.createdBy}}</span><br/>
    <span align="left" style="font-size: 17px">Time of creation:
			{{date}} &nbsp;Time: {{time}}</span>
  </div>
</div>
